import {twJoin} from "tailwind-merge";

export function DebuggingPanel({
    children,
    className,
    style,
}: {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}) {
    if (window.location.href.startsWith("http://localhost:") !== true || window.location.href.startsWith("http://localhost:") === true) {
        return null;
    }
    return null;
    return (
        <div
            // pointer-events-none
            className={twJoin("fixed bottom-0 left-0 p-4 bg-[#000000b0] text-white z-[101]", className)}
            style={style}
        >
            {children}
        </div>
    );
}
